function categories() {
    if (!document.body.classList.contains('categories')) {
        return;
    }

    const links = Array.from(document.querySelectorAll('.b-tools-categories-nav-inner a'));
    const groups = Array.from(document.querySelectorAll('.b-tools-categories-groups .b-tools-categories'));

    if (!links.length || !groups.length || !('IntersectionObserver' in window)) {
        return;
    }

    const linksByTarget = new Map(
        links.map((link) => [link.hash.replace('#', ''), link])
    );

    const setActiveLink = (targetId) => {
        links.forEach((link) => link.classList.toggle('active', link === linksByTarget.get(targetId)));
    };

    const observer = new IntersectionObserver((entries) => {
        const visibleEntry = entries.find((entry) => entry.isIntersecting);

        if (visibleEntry) {
            setActiveLink(visibleEntry.target.id);
        }
    }, {
        rootMargin: '-120px 0px -60% 0px',
        threshold: 0,
    });

    groups.forEach((group) => observer.observe(group));
    setActiveLink(groups[0].id);
}

export {categories};
